<template>
  <div class="pagination">
    <span class="pageactive" @click="toPageFirst">首页</span>
    <div class="page">
      <Page :current="current" :page-size="pageSize" @on-change="pageChange" :total="total"></Page>
    </div>
    <span class="pageactive" @click="toPageLast">末页</span>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    //当前页码
    current: {
      type: Number,
      default: 1
    },
    //每页条数
    pageSize: {
      type: Number,
      default: 4
    },
    //数据总数
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  methods: {
    // 首页
    toPageFirst() {
      this.$emit('toPageFirst')
    },
    // 末页
    toPageLast() {
      this.$emit('toPageLast')
    },
    // 分页
    pageChange(page) {
      this.$emit('pageChange', page)
    },
  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-page-prev::after {
  content: '';
  position: absolute;
  bottom: 50px;
  left: 33px;
  height: 69px;
  background: url("../assets/img/page_left.png") no-repeat;
  width: 69px;
  background-size: cover;
}


/deep/ .ivu-page-next::after {
  content: '';
  position: absolute;
  bottom: 50px;
  right: 33px;
  height: 69px;
  float: right;
  background: url("../assets/img/page_right.png");
  width: 69px;
  background-size: cover;
}

@media screen and (max-width: 1280px) {
  .pagination {
    padding-bottom: 50px;
    position: relative;
  }

  /deep/ .pageactive {
    display: none;
  }

  /deep/ .ivu-page-prev {
    min-width: 28px !important;
    width: 69px !important;
    height: 69px !important;
    line-height: 69px !important;
    border-radius: 69px !important;
    border: none !important;
    text-align: center;
    float: left;
    margin-left: 33px;
  }


  /deep/ .ivu-page-next a, /deep/ .ivu-page-prev a {
    font-size: 25px;
    display: none;
  }

  /deep/ .ivu-page-next {
    min-width: 69px !important;
    width: 69px !important;
    height: 69px !important;
    line-height: 69px !important;
    border-radius: 69px !important;
    border: none !important;
    text-align: center;
    float: right;
    margin-right: 33px;

  }

  /deep/ .ivu-page-item-jump-prev {
    width: 28px !important;
    min-width: 28px !important;
    height: 28px !important;
    line-height: 28px !important;
    border-radius: 28px !important;
    border: 1px solid #1AA7EC !important;
    text-align: center;
    display: none;

  }

  /deep/ .ivu-page-item-jump-next {
    width: 28px !important;
    min-width: 28px !important;
    height: 28px !important;
    line-height: 28px !important;
    border-radius: 28px !important;
    border: 1px solid #1AA7EC !important;
    text-align: center;
    display: none;

  }

  /deep/ .ivu-page-item {
    color: #333;
    font-size: 30px;
    border: none;
    display: none;
  }

  /deep/ .ivu-page-item-active a, .ivu-page-item-active:hover a {
    color: #1AA7EC;
    font-size: 30px;
    border: none;
    display: none;
  }

  /deep/ .ivu-page-disabled a {
    color: #1AA7EC;
    font-size: 25px;
    display: none;
  }

  /deep/ .ivu-icon {
    margin-top: -7px;
    display: none;
  }
}

@media screen and (min-width: 1280px) {
  .pagination {
    display: flex;
    justify-content: center;
    margin-top: 18px;

    .pageactive {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #5280B6;
      margin-right: 30px;
      margin-left: 30px;
      line-height: 30px;
      cursor: pointer;
    }
  }

  /deep/ .ivu-page-prev {
    min-width: 28px !important;
    width: 28px !important;
    height: 28px !important;
    line-height: 28px !important;
    border-radius: 28px !important;
    border: 1px solid #1AA7EC !important;
    text-align: center;
    margin: 0;
  }

  /deep/ .ivu-page-next {
    min-width: 28px !important;
    width: 28px !important;
    height: 28px !important;
    line-height: 28px !important;
    border-radius: 28px !important;
    border: 1px solid #1AA7EC !important;
    text-align: center;
    margin: 0;
  }

  /deep/ .ivu-page-item-jump-prev {
    width: 28px !important;
    min-width: 28px !important;
    height: 28px !important;
    line-height: 28px !important;
    border-radius: 28px !important;
    border: 1px solid #1AA7EC !important;
    text-align: center;
  }

  /deep/ .ivu-page-item-jump-next {
    width: 28px !important;
    min-width: 28px !important;
    height: 28px !important;
    line-height: 28px !important;
    border-radius: 28px !important;
    border: 1px solid #1AA7EC !important;
    text-align: center;
  }

  /deep/ .ivu-page-item {
    border: none;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 16px;
    color: #5280B6;
  }

  /deep/ .ivu-page-item-active a, .ivu-page-item-active:hover a {
    color: #5280B6;
    font-size: 16px;
    border: none;
  }

  /deep/ .ivu-page-disabled a {
    color: #1AA7EC;
    font-size: 16px;
  }

  /deep/ .ivu-icon {
    margin-top: -7px;
  }

  /deep/ .ivu-page-prev::after {
    content: '';
    position: absolute;
    bottom: 50px;
    left: 33px;
    height: 69px;
    background: url("../assets/img/page_left.png") no-repeat;
    width: 69px;
    background-size: cover;
    display: none;
  }

  /deep/ .ivu-page-next::after {
    content: '';
    position: absolute;
    bottom: 50px;
    right: 33px;
    height: 69px;
    float: right;
    background: url("../assets/img/page_right.png");
    width: 69px;
    background-size: cover;
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pagination.vue